import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();

  const navigation = [
    { name: '홈', path: '/', icon: '🏠' },
    { name: '팟캐스트', path: '/podcast', icon: '🎧' },
    { name: '요약정리', path: '/summary', icon: '📚' },
    { name: '마인드맵', path: '/mindmap', icon: '🗺️' },
    { name: '퀴즈', path: '/quiz', icon: '📝' },
    { name: '파슨스', path: '/parsons', icon: '🧩' },
    { name: 'AI 면접', path: '/interview', icon: '🤖' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <span className="text-2xl">📚</span>
              <span className="text-xl font-bold text-gray-800">NCS 학습도우미</span>
            </Link>
            
            <div className="hidden md:flex space-x-1">
              {navigation.map((item) => (
                item.path === '/mindmap' ? (
                  <a
                    key={item.path}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 rounded-lg text-sm font-medium transition-colors text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  >
                    <span className="mr-2">{item.icon}</span>
                    {item.name}
                  </a>
                ) : (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                      location.pathname === item.path
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <span className="mr-2">{item.icon}</span>
                    {item.name}
                  </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-1">
        {children}
      </main>

      <footer className="bg-white border-t mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center text-gray-600">
            <p>© 2025 NCS 학습도우미. NCS 기반 개발자 역량 향상을 지원합니다.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;